module.exports = __webpack_public_path__ + "static/media/feature2analytics.a8e15010.png";